import {
    AtualizarBoletoEnviadoCasoCobrancaNegociacaoParcelasService,
    AtualizarBoletoGeradoCasoCobrancaNegociacaoParcelasService,
    AtualizarBoletoNaoEnviadoCasoCobrancaNegociacaoParcelasService,
    AtualizarBoletoNaoQuitadoCasoCobrancaNegociacaoParcelasParcelasService,
    AtualizarBoletoQuitadoCasoCobrancaNegociacaoParcelasService,
} from "../../../Services/Cobranca/CasoCobrancaNegociacaoParcelas/CasoCobrancaNegociacaoParcelasServices";
import { Controller } from "../../Controller";

export async function AtualizarBoletoQuitadoCasoCobrancaNegociacaoParcelasController(
    idCasoCobrancaNegociacaoParcelas: number
) {
    return Controller(
        AtualizarBoletoQuitadoCasoCobrancaNegociacaoParcelasService(
            idCasoCobrancaNegociacaoParcelas
        )
    );
}

export async function AtualizarBoletoNaoQuitadoCasoCobrancaNegociacaoParcelasParcelasController(
    idCasoCobrancaNegociacaoParcelas: number
) {
    return Controller(
        AtualizarBoletoNaoQuitadoCasoCobrancaNegociacaoParcelasParcelasService(
            idCasoCobrancaNegociacaoParcelas
        )
    );
}

export async function AtualizarBoletoEnviadoCasoCobrancaNegociacaoParcelasController(
    idCasoCobrancaNegociacaoParcelas: number
) {
    return Controller(
        AtualizarBoletoEnviadoCasoCobrancaNegociacaoParcelasService(
            idCasoCobrancaNegociacaoParcelas
        )
    );
}

export async function AtualizarBoletoNaoEnviadoCasoCobrancaNegociacaoParcelasController(
    idCasoCobrancaNegociacaoParcelas: number
) {
    return Controller(
        AtualizarBoletoNaoEnviadoCasoCobrancaNegociacaoParcelasService(
            idCasoCobrancaNegociacaoParcelas
        )
    );
}

export async function AtualizarBoletoGeradoCasoCobrancaNegociacaoParcelasController(
    idCasoCobrancaNegociacaoParcelas: number
) {
    return Controller(
        AtualizarBoletoGeradoCasoCobrancaNegociacaoParcelasService(
            idCasoCobrancaNegociacaoParcelas
        )
    );
}
